var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { useGetActiveMachinesListQuery } from '../../../../../application/features/machines/machine-api';
import { useUpdateTechnicianMachinesMutation } from '../../../../../application/features/technicians/technician-api';
import useTranslate from '../../../../../localization/helpers';
var UpdateMachinesDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, technician = _a.technician;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var _c = useGetActiveMachinesListQuery({
        companyId: technician.companyId,
        filterByCompany: true
    }).data, machines = _c === void 0 ? [] : _c;
    var _d = __read(useUpdateTechnicianMachinesMutation(), 2), updateMachines = _d[0], _e = _d[1], isLoading = _e.isLoading, isSuccess = _e.isSuccess;
    var _f = useForm({
        defaultValues: {
            technicianId: '',
            machines: []
        }
    }), control = _f.control, reset = _f.reset, handleSubmit = _f.handleSubmit, errors = _f.formState.errors;
    useEffect(function () {
        var machines = technician.technicianMachines.map(function (machine) { return machine.machineId; });
        reset({
            technicianId: technician.userCompanyId,
            machines: machines
        });
    }, [reset, technician]);
    useEffect(function () {
        if (isSuccess) {
            reset();
            onClose();
            enqueueSnackbar(tWithField('toolTips.updateSuccess', 'common.assets'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var closeDialog = function () {
        reset();
        onClose();
    };
    var onSubmit = function (machines) {
        updateMachines(machines);
    };
    return (_jsxs(Dialog, { open: open, fullWidth: true, maxWidth: 'sm', onClose: closeDialog, children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }, children: [_jsx(Typography, { variant: 'h6', children: tWithFunction('actions.updateFunction', 'common.asset(s)') }), ' ', _jsx(IconButton, { size: 'Xs', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, { color: '#637381' }) })] }), _jsx(DialogContent, { children: _jsx(Controller, { name: 'machines', control: control, render: function (_a) {
                        var _b = _a.field, onChange = _b.onChange, value = _b.value;
                        return (_jsx(FormControl, { fullWidth: true, sx: { my: '10px' }, children: _jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), multiple: true, limitTags: 2, disableCloseOnSelect: true, disabled: isLoading, options: machines, getOptionLabel: function (option) { return option.name; }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.assets'), error: !!errors.machines }))); }, onChange: function (_, selectedOption) {
                                    onChange(selectedOption.map(function (x) { return x.id; }) || []);
                                }, value: machines.filter(function (machine) { return value.includes(machine.id); }), renderOption: function (props, option, _a) {
                                    var selected = _a.selected;
                                    return (_createElement("li", __assign({}, props, { key: option.id, value: option.id }),
                                        _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                        option.name));
                                }, renderValue: function (tagValue, getTagProps) {
                                    return tagValue.map(function (option, index) { return (_createElement(Chip, __assign({ size: 'small', variant: 'soft' }, getTagProps({ index: index }), { key: option.id, label: option.name }))); });
                                } }) }));
                    } }) }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: 'outlined', color: 'inherit', onClick: closeDialog, children: translate('actions.cancel') }), _jsx(Button, { disabled: isLoading, variant: 'contained', color: 'warning', onClick: handleSubmit(onSubmit), children: translate('actions.saveChanges') })] })] }));
};
export default UpdateMachinesDialog;
